import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformCanvas, transformCanvasGet } from './canvas.transformers';
import type { CanvasCollection } from './canvas.types';

export function canvasReducer(
  state: CollectionStateSlice<CanvasCollection> = {},
  action: CollectionActions<CanvasCollection>,
): CollectionStateSlice<CanvasCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'canvas') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<CanvasCollection>(
          state,
          transformIntoDocuments(result.canvases, transformCanvasGet),
          order,
          ref,
        );
      }

      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'canvas') {
        const { ref, result } = action.payload;

        return mergeWebsocketDocuments<CanvasCollection>(
          state,
          transformIntoDocuments([result], transformCanvas),
          ref,
        );
      }

      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'canvas') {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<CanvasCollection>(
          state,
          transformIntoDocuments([result.canvas], transformCanvasGet),
          ref,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
